import { render, staticRenderFns } from "./PtChip.vue?vue&type=template&id=71fe28db&scoped=true&"
import script from "./PtChip.vue?vue&type=script&lang=js&"
export * from "./PtChip.vue?vue&type=script&lang=js&"
import style0 from "./PtChip.vue?vue&type=style&index=0&id=71fe28db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fe28db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
